export const getLoginStatus = (isLoggedIn) => (isLoggedIn ? 'logged' : 'guest')

export const getStoreCountry = (locale) => locale?.split('-')?.[1]

export const getSiteLanguage = (locale) => locale?.split('-')?.[0]
